"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProcess = void 0;
const Sentry = __importStar(require("@sentry/react"));
const api_1 = require("core/api");
/* eslint-disable @typescript-eslint/ban-ts-comment */
const React = __importStar(require("react"));
const react_router_1 = require("react-router");
const useNavigation_1 = require("src/hooks/useNavigation");
const useRequest_1 = require("src/hooks/useRequest");
const useProcess = () => {
    const { teamId } = (0, react_router_1.useParams)();
    const location = (0, react_router_1.useLocation)();
    const urlParams = new URLSearchParams(location.search);
    const checkoutContext = urlParams?.get('checkoutContext') || api_1.CheckoutContext.ONBOARDING;
    const processor = urlParams?.get('processor') || api_1.Processor.STRIPE;
    const sessionId = urlParams?.get('checkoutSessionId') ?? '';
    const { isProcessing, makeRequest } = (0, useRequest_1.useRequest)();
    const { navigate } = (0, useNavigation_1.useNavigation)();
    const processSubscription = async () => {
        if (!teamId) {
            return;
        }
        const successMessage = checkoutContext === api_1.CheckoutContext.ONBOARDING || checkoutContext === api_1.CheckoutContext.TEAM_UPDATE
            ? 'Success!'
            : undefined;
        const { data } = await makeRequest(() => api_1.TeamService.processSubscription(+teamId, {
            sessionId,
            processor,
            checkoutContext: checkoutContext,
        }), successMessage);
        if (data?.success) {
            // @ts-ignore
            if (window?.webkit?.messageHandlers?.webCheckoutObserver) {
                // @ts-ignore
                window.webkit.messageHandlers.webCheckoutObserver.postMessage({
                    event: 'flowFinished',
                });
                return;
            }
            if (checkoutContext === api_1.CheckoutContext.ONBOARDING) {
                setTimeout(() => {
                    navigate.classicTeamSetup(teamId);
                }, 1000);
            }
            else if (checkoutContext === api_1.CheckoutContext.TEAM_UPDATE) {
                setTimeout(() => {
                    navigate.classicTeamBilling();
                }, 1000);
            }
            else if (checkoutContext === api_1.CheckoutContext.SUBSCRIPTION_MANAGE) {
                setTimeout(() => {
                    navigate.v1TeamPlanManage(+teamId);
                }, 500);
            }
            else {
                navigate.classicTeamBilling();
            }
        }
        else {
            Sentry.captureException(new Error(`Failed to process subscription for team`), {
                level: 'fatal',
                extra: {
                    teamId,
                    sessionId,
                    processor,
                    checkoutContext,
                },
            });
        }
    };
    const refreshSubscription = async () => {
        if (!teamId) {
            return;
        }
        const { data } = await makeRequest(() => api_1.TeamService.refreshTeamSubscription(+teamId));
        if (data?.success) {
            navigate.classicTeamBilling();
        }
    };
    React.useEffect(() => {
        if (checkoutContext === api_1.CheckoutContext.ONBOARDING ||
            checkoutContext === api_1.CheckoutContext.TEAM_UPDATE ||
            checkoutContext === api_1.CheckoutContext.SUBSCRIPTION_MANAGE) {
            processSubscription();
        }
        if (checkoutContext === api_1.CheckoutContext.PORTAL) {
            refreshSubscription();
        }
    }, []);
    return {
        isProcessing,
        checkoutContext,
    };
};
exports.useProcess = useProcess;
